import LogItem from '../LogItem/LogItem';
import type { LogListProps } from './LogList.types';

const LogList = ({ logs }: LogListProps) => {
  return (
    <div className="flex gap-4 items-center flex-wrap min-w-0 overflow-hidden">
      {logs.map((log, index) => (
        <LogItem key={`${log.label}-${index}`} label={log.label} value={String(log.value)} />
      ))}
    </div>
  );
};

export default LogList;
